var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeExportacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.76762 12.551C8.53739 12.7504 8.53739 13.1075 8.76762 13.3069L11.1856 15.401C11.5094 15.6814 12.0129 15.4514 12.0129 15.023V14.3004H15.9166C16.1927 14.3004 16.4166 14.0766 16.4166 13.8004V12.0571C16.4166 11.781 16.1927 11.5571 15.9166 11.5571H12.0129V10.8349C12.0129 10.4066 11.5094 10.1765 11.1856 10.457L8.76762 12.551Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56215 0.973633H12.7418C13.2202 0.973633 13.6081 1.36149 13.6081 1.83993V9.31173C13.6081 9.47121 13.4788 9.60049 13.3193 9.60049C13.1598 9.60049 13.0305 9.47121 13.0305 9.31173V1.83993C13.0305 1.68045 12.9012 1.55116 12.7418 1.55116H3.97052V4.07786C3.97052 4.5563 3.58267 4.94415 3.10423 4.94415H0.57753V16.1338C0.57753 16.2933 0.706815 16.4226 0.866296 16.4226H10.937C11.0965 16.4226 11.2257 16.5519 11.2257 16.7113C11.2257 16.8708 11.0965 17.0001 10.937 17.0001H0.866296C0.387854 17.0001 0 16.6122 0 16.1338V4.53578L3.56215 0.973633ZM0.985906 4.36662H3.10423C3.26371 4.36662 3.39299 4.23734 3.39299 4.07786V1.95954L0.985906 4.36662Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87695 6.38813C1.87695 6.22865 2.00624 6.09937 2.16572 6.09937H12.2003C12.3598 6.09937 12.4891 6.22865 12.4891 6.38813C12.4891 6.54761 12.3598 6.6769 12.2003 6.6769H2.16572C2.00624 6.6769 1.87695 6.54761 1.87695 6.38813Z",
    fill: "currentColor",
    fillOpacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87695 8.98701C1.87695 8.82753 2.00624 8.69824 2.16572 8.69824H10.576C10.7355 8.69824 10.8648 8.82753 10.8648 8.98701C10.8648 9.14649 10.7355 9.27577 10.576 9.27577H2.16572C2.00624 9.27577 1.87695 9.14649 1.87695 8.98701Z",
    fill: "currentColor",
    fillOpacity: 0.55
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87695 11.5856C1.87695 11.4262 2.00624 11.2969 2.16572 11.2969H7.39959C7.55907 11.2969 7.68835 11.4262 7.68835 11.5856C7.68835 11.7451 7.55907 11.8744 7.39959 11.8744H2.16572C2.00624 11.8744 1.87695 11.7451 1.87695 11.5856Z",
    fill: "currentColor",
    fillOpacity: 0.55
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87695 14.1845C1.87695 14.025 2.00624 13.8958 2.16572 13.8958H7.39959C7.55907 13.8958 7.68835 14.025 7.68835 14.1845C7.68835 14.344 7.55907 14.4733 7.39959 14.4733H2.16572C2.00624 14.4733 1.87695 14.344 1.87695 14.1845Z",
    fill: "currentColor",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeExportacao);
export default __webpack_public_path__ + "static/media/iconeExportacao.b5a211dfea5456c3f62467c89668eeb4.svg";
export { ForwardRef as ReactComponent };